import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Globe } from 'lucide-react';
interface SlideCTAProps {
  onContinue: () => void;
}
export function SlideCTA({
  onContinue
}: SlideCTAProps) {
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative overflow-hidden" data-id="element-190">
      {/* Subtle radial glow */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(45,212,191,0.08),transparent_60%)]" data-id="element-191" />

      <div className="z-10 max-w-5xl w-full flex flex-col items-center" data-id="element-192">
        {/* Logo mark */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-193">
          <img src="https://cdn.magicpatterns.com/uploads/vHi8C8sCgwMCZwFWE662Vf/Snakker2.0_Logo_Main.png" alt="Snakker" className="h-24 w-auto brightness-0 invert" data-id="element-194" />
        </motion.div>

        {/* Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="space-y-2" data-id="element-195">
          <h1 className="text-4xl md:text-6xl font-sans font-bold tracking-tight leading-[1.1]" data-id="element-196">
            <span className="text-white" data-id="element-197">AI changed campaign economics.</span>
            <br data-id="element-198" />
            <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-teal-400 bg-clip-text text-transparent" data-id="element-199">
              Snakker changes what pharma
              <br data-id="element-200" />
              can do with them.
            </span>
          </h1>
        </motion.div>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.35
      }} className="text-lg md:text-xl text-white/50 font-medium mt-8" data-id="element-201">
          Unlocking the long tail of pharma growth.
        </motion.p>

        {/* Contact */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.6
      }} className="mt-16 flex flex-col sm:flex-row items-center gap-3 sm:gap-4" data-id="element-202">
          <a href="mailto:rds@snakker.io" className="group flex items-center gap-3 px-6 py-3.5 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-teal-400/40 transition-all" data-id="element-203">
            <div className="w-9 h-9 rounded-full bg-teal-400/10 border border-teal-400/30 flex items-center justify-center text-teal-400 group-hover:scale-110 transition-transform" data-id="element-204">
              <Mail className="w-4 h-4" data-id="element-205" />
            </div>
            <div className="text-left" data-id="element-206">
              <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold" data-id="element-207">
                Contact
              </p>
              <p className="text-white font-semibold text-sm" data-id="element-208">
                Richard dos Santos · rds@snakker.io
              </p>
            </div>
          </a>

          <a href="https://www.snakker.io" target="_blank" rel="noreferrer" className="group flex items-center gap-3 px-6 py-3.5 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-teal-400/40 transition-all" data-id="element-209">
            <div className="w-9 h-9 rounded-full bg-teal-400/10 border border-teal-400/30 flex items-center justify-center text-teal-400 group-hover:scale-110 transition-transform" data-id="element-210">
              <Globe className="w-4 h-4" data-id="element-211" />
            </div>
            <div className="text-left" data-id="element-212">
              <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold" data-id="element-213">
                Visit
              </p>
              <p className="text-white font-semibold text-sm" data-id="element-214">www.snakker.io</p>
            </div>
          </a>
        </motion.div>
      </div>
    </div>;
}